import React, { useState } from 'react';
import * as api from '../../../api/contentStudioV2';
import { useLanguage } from '../../../contexts/LanguageContext';

const Step4EvidenceMode = ({ sessionId, token, onComplete, onBack, setError, setLoading }) => {
  const [selected, setSelected] = useState(null);
  const { t } = useLanguage();

  const modes = [
    { id: 'Scientific', icon: '🔬', get title() { return t('cs.steps.evidence.scientific'); }, get desc() { return t('cs.steps.evidence.scientificDesc'); } },
    { id: 'Emotional', icon: '❤️', get title() { return t('cs.steps.evidence.emotional'); }, get desc() { return t('cs.steps.evidence.emotionalDesc'); } },
    { id: 'Hybrid', icon: '⚖️', get title() { return t('cs.steps.evidence.hybrid'); }, get desc() { return t('cs.steps.evidence.hybridDesc'); } }
  ];

  const handleContinue = async () => {
    if (!selected) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const result = await api.setEvidenceMode(token, sessionId, selected);
      onComplete({ evidenceMode: selected, aiGuidance: result.ai_guidance });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: '#fff', borderRadius: '12px', padding: '20px' }}>
      <h2 style={{ fontSize: '20px', color: '#333', marginBottom: '16px' }}>
        {t('cs.steps.evidence.title')}
      </h2>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {modes.map(mode => (
          <div
            key={mode.id}
            onClick={() => setSelected(mode.id)}
            style={{
              padding: '16px',
              border: selected === mode.id ? '2px solid #0e67a2' : '1px solid #ddd',
              borderRadius: '10px',
              background: selected === mode.id ? '#E8F4FF' : '#fff',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ fontSize: '28px' }}>{mode.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '16px', fontWeight: 600, color: '#333' }}>{mode.title}</div>
                <div style={{ fontSize: '13px', color: '#666', marginTop: '2px' }}>{mode.desc}</div>
              </div>
              {selected === mode.id && <div style={{ color: '#0e67a2', fontSize: '20px' }}>✓</div>}
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
        <button onClick={onBack} style={{ flex: 1, padding: '14px', background: '#fff', border: '2px solid #0e67a2', borderRadius: '12px', color: '#0e67a2', fontSize: '15px', fontWeight: 600, cursor: 'pointer' }}>
          {t('cs.buttons.back')}
        </button>
        <button onClick={handleContinue} disabled={!selected} style={{ flex: 2, padding: '14px', background: selected ? '#F7941E' : '#ccc', border: 'none', borderRadius: '12px', color: '#fff', fontSize: '15px', fontWeight: 600, cursor: selected ? 'pointer' : 'not-allowed' }}>
          {t('cs.buttons.continue')}
        </button>
      </div>
    </div>
  );
};

export default Step4EvidenceMode;